import React from 'react';
import contact_img from "../Assets/images/contact_img.png"
import { Accordion, Form } from 'react-bootstrap';
import { Email, PermPhoneMsg, PinDrop } from '@mui/icons-material';
import { email, main_address, phone_number } from '../config/details';
import contact_1 from "../Assets/images/contact_1.png";
import contact_2 from "../Assets/images/contact_2.png";
import contact_3 from "../Assets/images/contact_3.png";



const Contact = () => {





  return (
    <>
      <div className="contact_page">
        <div className="contact_baner">
          <div className="container-layout">
            <div className="row contact_row">
              <div className="col-md-12 col-lg-6 col-xl-7">
                <div className="contact_left">
                  <h1>Contact Us</h1>
                  <p>
                    Our company was founded in 2019. We work daily to become better and we are ready to share best practices.
                  </p>


                  <Form>
                    <div className="row form_row">
                      <div className="col-md-6 col-lg-6 col-xl-6">
                        <Form.Group className="mb-4" controlId="formBasicEmail">
                          <Form.Control type="text" placeholder="Your name" />
                        </Form.Group>
                      </div>

                      <div className="col-md-6 col-lg-6 col-xl-6">
                        <Form.Group className="mb-4" controlId="formBasicEmail">
                          <Form.Control type="email" placeholder="Your email" />
                        </Form.Group>
                      </div>

                      <div className="col-md-12 col-lg-12 col-xl-12">

                        <Form.Group className="mb-4" controlId="formBasicEmail">
                          <Form.Control
                            as="textarea"
                            placeholder="Write your comment"
                            style={{ height: '100px' }}
                          />
                        </Form.Group>


                      </div>

                      <div className="col-md-12 col-lg-12 col-xl-12">
                        <div className="form__submit">
                          <button><span>Submit</span></button>
                        </div>
                      </div>


                    </div>
                  </Form>


                </div>
              </div>

              <div className="col-md-12 col-lg-6 col-xl-5">
                <div className="contact_right">
                  <img src={contact_img} alt='contact_img' />
                  <div className="circle_iamge"></div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <div className="address_sec">
          <div className="container-layout">
            <h2 className='text-center'>Contact <span>With Us</span></h2>
            <div className="row">

              <div className="col-md-12 col-lg-6 col-xl-6 mt-4">
                <div className="card">
                  <div className="detail">
                    <div className="icon_bg">
                      <PinDrop />
                    </div>

                    <div className="div">
                      <div className="card_title">Abohar Address</div>
                      <div className="card_text">
                        <a href={`https://www.google.com/maps?q=${encodeURIComponent(main_address)}`} target="_blank" rel="noopener noreferrer"> {main_address} </a>
                      </div>
                    </div>
                  </div>

                  {/* <div className="detail">
                    <div className="icon_bg">
                      <PinDrop />
                    </div>

                    <div className="div">
                      <div className="card_title">Mohali Address</div>
                      <div className="card_text">
                        <a href={`https://www.google.com/maps?q=${encodeURIComponent(main_address)}`} target="_blank" rel="noopener noreferrer"> {first_address} </a>
                      </div>
                    </div>
                  </div> */}
{/* 
                  <div className="detail">
                    <div className="icon_bg">
                      <PinDrop />
                    </div>

                    <div className="div">
                      <div className="card_title">Gujarat Address</div>
                      <div className="card_text">
                        <a href={`https://www.google.com/maps?q=${encodeURIComponent(main_address)}`} target="_blank" rel="noopener noreferrer"> {second_address} </a>
                      </div>
                    </div>
                  </div> */}

                </div>
              </div>

              <div className="col-md-12 col-lg-6 col-xl-6 mt-4">
                <div className="card">
                  <div className="detail">
                    <div className="icon_bg">
                      <PermPhoneMsg />
                    </div>

                    <div className="div">
                      <div className="card_title">Phone No</div>
                      <div className="card_text">
                        <a target='_black' href={`tel:${phone_number}`}> {`+91 ` + phone_number} </a>
                      </div>
                      {/* <div className="card_text">
                        <a target='_black' href={`tel:${phone_number2}`}> {`+91 ` + phone_number2} </a>
                      </div>
                      <div className="card_text">
                        <a target='_black' href={`tel:${phone_number3}`}> {`+91 ` + phone_number3} </a>
                      </div> */}
                    </div>
                  </div>

                  <div className="detail mt-4">
                    <div className="icon_bg">
                      <Email />
                    </div>

                    <div className="div">
                      <div className="card_title">Email</div>
                      <div className="card_text">
                        <a target='_black' href={`mailto:${email}`}> {email} </a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>

          </div>

        </div>

        <div className="help_sec">
          <div className="container-layout">
            <h2 className='text-center'>How can we help you <span>Right now</span></h2>
            <div className="row">
              <div className="col-md-6 col-lg-4 col-xl-4">
                <div className="card">

                  <img src={contact_1} alt='' />
                  <div className="detail">
                    <div className="card_title">Ask a question</div>
                    <div className="card_text">
                      Cras eu semper neque, sit amet aliquet odio. Donec volutpat enim quis mollis consequat.
                    </div>
                  </div>

                </div>

              </div>

              <div className="col-md-6 col-lg-4 col-xl-4">
                <div className="card">
                  <img src={contact_2} alt='' />

                  <div className="detail">
                    <div className="card_title">Ask a question</div>
                    <div className="card_text">
                      Cras eu semper neque, sit amet aliquet odio. Donec volutpat enim quis mollis consequat.
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-md-6 col-lg-4 col-xl-4">
                <div className="card">
                  <img src={contact_3} alt='' />

                  <div className="detail">
                    <div className="card_title">Ask a question</div>
                    <div className="card_text">
                      Cras eu semper neque, sit amet aliquet odio. Donec volutpat enim quis mollis consequat.
                    </div>
                  </div>


                </div>
              </div>
            </div>

          </div>

        </div>

        <div className="faq_sec">
          <div className="container-layout">
            <h2 className='text-center'>Frequently Asked <span>Questions</span></h2>
            <p className='text-center'>The right way to help investors is by integrating all reward programs into the platform</p>

            <div className="row">
              <div className="col-lg-12 col-xl-12">
                <div className="faq_accordion">
                  <Accordion defaultActiveKey="0">

                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Do is need to install any software?</Accordion.Header>
                      <Accordion.Body>
                        LessAccounting is 100% web-based, meaning it can be accessed from anywhere and there’s no software to install on your computer. You can easily use LessAccounting on your iPhone or any Android mobile device with our cloud accounting. That is what makes it the best small business accounting software options among accounting programs.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Do is need to install any software?</Accordion.Header>
                      <Accordion.Body>
                        LessAccounting is 100% web-based, meaning it can be accessed from anywhere and there’s no software to install on your computer. You can easily use LessAccounting on your iPhone or any Android mobile device with our cloud accounting. That is what makes it the best small business accounting software options among accounting programs.
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                      <Accordion.Header>Do is need to install any software?</Accordion.Header>
                      <Accordion.Body>
                        LessAccounting is 100% web-based, meaning it can be accessed from anywhere and there’s no software to install on your computer. You can easily use LessAccounting on your iPhone or any Android mobile device with our cloud accounting. That is what makes it the best small business accounting software options among accounting programs.
                      </Accordion.Body>
                    </Accordion.Item>


                  </Accordion>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div >

    </>
  );
}

export default Contact;
